import type { User } from "@/types";

/** Dashboard permission helpers - align keys and OR semantics with backend `PermissionsGuard`. */

/** True if JWT `permissions` includes at least one of the required keys (dot format). No roleKey bypass - assign permissions via roles. */
export function userHasPermission(user: User | null, permission: string | string[]): boolean {
	if (!user) return false;
	const perms = user.permissions || [];
	const required = Array.isArray(permission) ? permission : [permission];
	return required.some(p => perms.includes(p));
}

/**
 * After login, prefer `preferredPath` (e.g. `location.state.from.pathname`).
 * When the default home `/` would be denied (no `dashboard.read`), send users to `/profile` instead of a redirect hop.
 */
export function getPostLoginRedirect(preferredPath: string | undefined, user: User): string {
	let path = (preferredPath ?? "/").trim() || "/";
	if (path === "/login") {
		path = "/";
	}
	if (path === "/" && !userHasPermission(user, "dashboard.read")) {
		return "/profile";
	}
	return path;
}
